import MiddleSection from "./middleSection";

export default MiddleSection;
